import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function deleteUserFiles(
  userUid: string,
  fileIds: string[],
  auth: Authentication | null
): Promise<void> {
  try {
    if (!auth) throw new DeleteUserFilesFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.post(
      `/backoffice/users/${userUid}/files/delete`,
      { fileIds },
      auth.token
    );

    if (!response.success) throw new DeleteUserFilesFailure(response.message, response.code);
  } catch (e) {
    if (e instanceof DeleteUserFilesFailure) throw e;
    const errMessage = e instanceof Error ? e.message : 'Une erreur inattendue s’est produite.';
    throw new DeleteUserFilesFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed'
    );
  }
}

export class DeleteUserFilesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteUserFiles;
